import styles from './AdminFamilyGroupsAsMember.module.css';
import iconExit from '../../../../assets/img/icons/icon-exit-group.png';
import { Text } from '../../../../components/UI';
import { RelationshipDataAsMember } from '../../interface/RelationshipDataAsMember';

interface AdminFamilyGroupsAsMemberProps {
  data: RelationshipDataAsMember[];
  onExitGroup: (relationshipData: RelationshipDataAsMember) => void;
}

export const AdminFamilyGroupsAsMember = ({ data, onExitGroup }: AdminFamilyGroupsAsMemberProps) => {
  return (
    <div className={styles.groups}>
      {data.map((familyGroup) => (
        <div key={familyGroup.id} className={styles.group}>
          <Text>
            Integrante en Grupo familiar de {familyGroup.patient_leader.first_name} {familyGroup.patient_leader.last_name} - {familyGroup.type_relationship.name}
          </Text>
            <div className={styles.button__container}>
              <button 
              className={styles.group__button} 
              onClick={() => onExitGroup(familyGroup)}
            >
              <img src={iconExit} className={styles.button__icon} alt="Salir del grupo" />
              <span className={styles.button__text}>Eliminar del grupo</span>
              </button>
            </div>
        </div>
      ))}
    </div>
  )
}
